import { render, staticRenderFns } from "./MappingList.vue?vue&type=template&id=1241d4ac&"
import script from "./MappingList.vue?vue&type=script&lang=js&"
export * from "./MappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports